import { useState } from "react";
import Swal from "sweetalert2";
import Step1 from "../components/Registro/Step1";
import EmailVerification from "../components/Registro/EmailVerification";
import LoadingSvg from "../components/Loading";
import { useNavigate } from "react-router-dom";

export default function Registration() {
  const navigate = useNavigate();

  // 1 = Step1, 2 = EmailVerification
  const [step, setStep] = useState(1);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleNext = async (formData) => {
    const updatedData = { ...data, ...formData };
    setData(updatedData);

    // ✅ Step 1: register + send verification code
    if (step === 1) {
      setLoading(true);
      try {
        const bodyFinal = {
          first_name: updatedData.first_name,
          second_name: updatedData.second_name,
          last_name: updatedData.last_name,
          email: updatedData.email,
          organization: updatedData.organization,
          country: updatedData.country || null,
          password: updatedData.password,

        };

        console.log("📤 Sending to backend:", bodyFinal);

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/register`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyFinal),
          },
        );

        const result = await res.json();

        if (!res.ok) {
          throw new Error(result.error || "Registration failed");
        }

        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Verification code sent to your email, please check your inbox. Make sure to check the spam folder if you don't see it.",
          confirmButtonColor: "#3085d6",
        });
        setStep(2); // ✅ go to verification screen
      } catch (err) {
        console.error("REGISTER ERROR:", err);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message,
          confirmButtonColor: "#3085d6",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <LoadingSvg size={400} pulse />
        </div>
      )}

      {step === 1 && <Step1 onNext={handleNext} />}

      {step === 2 && (
        <EmailVerification
          email={data.email}
          onVerify={(token) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Email verified successfully!",
              confirmButtonColor: "#3085d6",
            }).then(() => {
              navigate("/predashboard");
            });
          }}
        />
      )}
    </>
  );
}
